export const monthsOfYear = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const convertTimeStampToMonthAndYearFormat = (timestamp: Date, variant: 'long' | 'short' = 'long'): string => {
    const formatter = new Intl.DateTimeFormat('en-US', { month: variant, year: 'numeric' });
    return formatter.format(timestamp)
}

export const getDateFromTimeStamp = (date: Date | string | number): string => {
    const parsedDate = new Date(date);
    if (isNaN(parsedDate.getTime())) {
        throw new Error('Invalid date provided');
    }
    const formatter = new Intl.DateTimeFormat('en-US', { day: 'numeric', month: 'long', year: 'numeric' });
    return formatter.format(parsedDate);
};

export const convertToMilliseconds = (days: number, hours: number) => {
    const totalMilliseconds = days * 24 * 60 * 60 * 1000 + hours * 60 * 60 * 1000;
    return (totalMilliseconds);
};

export const getDateObjectFromTimeStamp = (date: Date | string | number): Date => {

    const parsedDate = new Date(date);
    if (isNaN(parsedDate.getTime())) {
        throw new Error('Invalid date provided');
    }
    return parsedDate;
};

export const getDateObjForCalendar = (timestamp: Date): { year: number, month: string, day: number } => {
    const date = new Date(timestamp);

    const data = {
        year: date.getFullYear(),
        month: monthsOfYear[date.getMonth()],
        day: date.getDate()
    };

    return data;
}